// @flow
import ConfirmActionModalContainer from './ConfirmActionModalContainer'
export default ConfirmActionModalContainer
